export default function dateInput(i18n) {
  if (i18n === "en") {
    return { dateFormat: "m/d/Y" };
  } else {
    return { dateFormat: "d/m/Y" };
  }
}
